import React from 'react';
import Modal from 'react-modal';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme } from '@mui/material';
import personImage from '../../image/personnew.png';

Modal.setAppElement('#root');

const UploadDocsRulesModal = ({ isOpen, onClose, onConfirm }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const modalStyle = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        content: {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            transform: 'none',
            width: isDesktop ? '45%' : '95%',
            maxHeight: '90vh',
            margin: 'auto',
            background: '#ffffff',
            overflow: 'auto',
            border: 'none',
            outline: 'none',
            borderRadius: '12px',
            padding: '24px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        }
    };

    const boxStyle = {
        borderRadius: '10px',
        padding: '24px',
    };

    const rules = [
        'لطفا کارت ملی خودرا هنگام ضبط در دست خود بگیرید',
        'پس زمینه ویدیو ساده و ترجیحا سفید باشد',
        'نور محیط باید به اندازه باشد و محیط تاریک نباشد',
        'تصویر شما بطور کامل در کادر و واضح باشد',
        'شدت صدا و بیان کلمات باید واضح و قابل تشخیص و محیط اطراف ساکت باشد',
        'تصویر شما نباید تفاوت بسیار زیاد با تصویر کارت ملی شما داشته باشد',
        'بطور مثال اگر در تصویر کارت ملی عینک ندارید، عینک نزنید',
        'ضمن رعایت شئونات اسلامی، جهت جلوگیری از خطا از آرایش اجتناب کنید',
        'درخواست مجوز دوربین توسط مرورگر خود را تایید کنید',
        'اگر سیستمی که با آن به سامانه وارد شده‌اید دسترسی به دوربین ندارد، می‌توانید از یک سیستم دیگر وارد سامانه شوید',
    ];

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Upload Docs Rules Modal"
            style={modalStyle}
        >
            <Box sx={boxStyle}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1rem' }}>
                    <img
                        src={personImage}
                        alt="person"
                        style={{
                            width: '150px',
                            height: '150px',
                            borderRadius: '10%',
                            objectFit: 'cover',
                            display: 'block',
                            margin: '0 auto'
                        }}
                    />
                </div>

                <h2 className="header-text mt-2 mb-2" style={{ color: '#044448', textAlign: 'center' }}>
                    قوانین ضبط ویدئو
                </h2>

                <p className="text-format mb-4" style={{ textAlign: 'center', color: '#4D4D4D' }}>
                    لطفا قوانین زیر را با دقت مطالعه کنید
                </p>

                <div className='rounded p-3 rule-modal rtl' style={{ maxHeight: '50vh' }}>
                    <div className='rtl'>
                        {rules.map((rule, index) => (
                            <div key={index} className='text-format-rule my-2' style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <span style={{ color: '#0BA9B5', marginLeft: '8px', fontWeight: 'bold' }}>
                                    {index + 1}-
                                </span>
                                <span>{rule}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'row', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    marginTop: '1.5rem',
                    gap: '0.75rem'
                }}>
                    <button
                        className='btn text-form-title'
                        onClick={onClose}
                        style={{ 
                            minWidth: '120px',
                            padding: '0.75rem 1.5rem',
                            border: '2px solid #D3D3D3',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            color: '#131313',
                            fontFamily: 'IRANYekanX',
                            fontSize: '16px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.borderColor = '#A0A0A0';
                            e.target.style.backgroundColor = '#F5F5F5';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.borderColor = '#D3D3D3';
                            e.target.style.backgroundColor = 'white';
                        }}
                    >
                        بستن
                    </button>
                    <button
                        className='btn text-form-button'
                        onClick={onConfirm}
                        style={{ 
                            minWidth: '120px',
                            padding: '0.75rem 1.5rem',
                            borderRadius: '8px',
                            backgroundColor: '#044448',
                            color: 'white',
                            fontFamily: 'IRANYekanX',
                            fontSize: '16px',
                            fontWeight: '600',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#022224';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = '#044448';
                        }}
                    >
                        تایید
                    </button>
                </div>
            </Box>
        </Modal>
    );
};

export default UploadDocsRulesModal;

